export default __webpack_public_path__ + "static/2-2b89b4e77b5315409b8969fb9acb8790.jpeg";